import {requestTimeout, handleResponse} from '../utils'
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL
// const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

// const cookie = new Cookies();

export const topicApi = {    
    _get,       
    _get_file, 
    _get_audio,
};



async function _get(slug) {

   
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'account/courses/topics/'+slug, requestOptions))                    
                .then(handleResponse)
                .then((response) => {    
                    return response
                })                
        
}

async function _get_file(path) {

   
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'account/'+path, requestOptions))                    
                .then(handleResponse)
                .then((response) => {    
                    return response
                })                
        
}



async function _get_audio(path) {

   
    const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)    
    const requestOptions = {
        method: 'GET',
        credentials: "include",
        headers: {
            'Authorization': 'Bearer '+ token,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return requestTimeout(apiMaxTime,fetch(apiUrl + 'account/'+path, requestOptions))                    
                // .then((response) => response.blob())                
                .then((res) => {    
                    // return URL.createObjectURL(res);
                    return res;
                })                
        
}